import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { GstViewRequest } from 'src/app/model/Purchase/PurchaseInvoice/GstViewRequest/gst-view-request';
import { OfferViewRequest } from 'src/app/model/Sale/Promotions/OfferViewRequest/offer-view-request';

export class DialogDataModel {

    requestView: RequestView | OfferViewRequest | any;
    excelFileName: string;
    subModuleName: string;

    //For purchase
    gstViewRequest: GstViewRequest;
}
